import { useState } from 'react'
import DialogModal from '../modal/DialogModal'
import Stepper from '../stepper'
import DynamicInputTable from '../dynamicInputTable'

interface MultiStepModalProps {
  isOpen: boolean
  handleClose: () => void
}

const MultiStepModal: React.FC<MultiStepModalProps> = ({
  isOpen,
  handleClose,
}) => {
  const [currentStep, setCurrentStep] = useState(0)

  const steps = ['Placement Details', 'Address', 'Rates']

  const handleStepClick = (step: number) => {
    setCurrentStep(step)
  }
  return (
    <DialogModal
      isOpen={isOpen}
      onClose={handleClose}
      small={false}
      title="Create New Placement"
      subTitle="Create New Placement"
      secondaryActionLabel="Close"
      secondaryAction={handleClose}
      customeHeadStyle="pb-2"
      body={
        <div className="flex flex-col px-5">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onStepClick={handleStepClick}
          />
          <div className="step-content">
            {currentStep === 0 && (
              <div>
                <DynamicInputTable />
              </div>
            )}
            {currentStep === 1 && <div>Content for Address</div>}
            {currentStep === 2 && <div>Content for Rates</div>}
          </div>
        </div>
      }
    />
  )
}

export default MultiStepModal
